import { Media } from "./media";

export class MarcasSend {

    constructor(item: MarcasSend | void) {
        if(item instanceof Object) {
            this.id = item.id;
            this.nome = item.nome;
            this.userId = item.userId;
            this.media = item.media;
            this.tipo = item.tipo;
            this.link = item.link;
        }
    }

    id: number = -1;
    nome: string = "";
    userId: string = "";
    tipo: string = "";
    link: string = "";
    media: Media[] = [];

    public toString() {
        return this.nome;
    }
}
export class Marcas {

    constructor(item: Marcas | void) {
        if(item instanceof Object) {
            this.id = item.id;
            this.nome = item.nome;
            this.media = item.media;
            this.tipo = item.tipo;
            this.link = item.link;
        }
    }

    id: number = -1;
    nome: string = "";
    media: string = "";
    tipo: string = "";
    link: string = "";

    public toString(): string {
        return this.nome;
    }
}
